import React from 'react';
import { TN_VIEWBOX, TN_ASPECT, TN_PATH } from '@/lib/tnMap';

// Accurate Tamil Nadu outline (projected from real latitude/longitude). Markers
// are positioned by mapX/mapY which are the SAME projection as the outline, so
// every city sits in its correct geographic place. offMap entries (e.g. an
// Andhra Pradesh project) are intentionally NOT plotted on the TN outline.
export const TamilNaduMap = ({ locations = [], activeName, onSelect }) => {
  const markers = locations.filter((l) => l.mapX != null && l.mapY != null && !l.offMap);
  return (
    <div
      className='relative w-full overflow-hidden rounded-2xl border border-white/10 bg-[#0c1113]'
      data-testid='tn-map'
    >
      <div className='relative mx-auto w-full' style={{ aspectRatio: String(TN_ASPECT), maxWidth: 560 }}>
        <svg viewBox={TN_VIEWBOX} preserveAspectRatio='xMidYMid meet' className='absolute inset-0 h-full w-full'>
          <defs>
            <linearGradient id='tnfill' x1='0' y1='0' x2='0' y2='1'>
              <stop offset='0%' stopColor='#114247' />
              <stop offset='100%' stopColor='#0a2a2d' />
            </linearGradient>
          </defs>
          <path
            d={TN_PATH}
            fill='url(#tnfill)'
            stroke='#B88A3B'
            strokeWidth='3'
            strokeOpacity='0.55'
            strokeLinejoin='round'
          />
        </svg>

        {markers.map((l) => {
          const isOffice = l.type === 'office';
          const isActive = activeName === l.name;
          return (
            <button
              key={l.name}
              type='button'
              onClick={() => onSelect && onSelect(l)}
              data-testid={`map-marker-${l.name}`}
              style={{ left: `${l.mapX}%`, top: `${l.mapY}%` }}
              className='group absolute -translate-x-1/2 -translate-y-1/2 focus:outline-none'
              aria-label={l.name}
            >
              <span
                className={`relative block rounded-full transition-transform duration-200 group-hover:scale-125 group-focus-visible:scale-125 ${
                  isOffice ? 'h-3.5 w-3.5 bg-[#B88A3B]' : 'h-3 w-3 bg-[#2bbec8]'
                } ${isActive ? 'scale-150 ring-2 ring-white/70' : ''}`}
              >
                <span
                  className={`absolute inset-0 rounded-full motion-safe:animate-ping ${
                    isOffice ? 'bg-[#B88A3B]/60' : 'bg-[#2bbec8]/50'
                  }`}
                />
              </span>
              <span
                className={`pointer-events-none absolute left-1/2 top-full mt-1 -translate-x-1/2 whitespace-nowrap rounded px-1.5 py-0.5 text-[10px] font-medium transition-opacity duration-200 ${
                  isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100'
                } ${isOffice ? 'text-[#F0C988]' : 'text-[#8fe0e6]'}`}
              >
                {l.name}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
